import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from "../../NotFound/NotFound";
import PurchaserStepperPages from "./scenes/PurchaserStepperPages";
import PurchaserPreviewPanel from "./scenes/preview/PurchaserPreviewPanel";

const rp = RouterPath.purchaserDemand;

function PurchaserDemand() {

    return (
        <Switch>
            {/*zmiana */}
            <Redirect exact from={RouterPath.DEMAND} to={RouterPath.MY_PROCEDURE} />
            <Redirect exact from={rp.PURCHASER_DEMAND_ID} to={RouterPath.myProcedure.steps.MP_1_ID} />
            <Redirect exact from={rp.PURCHASER_DEMAND_ID_OFFER} to={RouterPath.myProcedure.steps.MP_1_ID} />
            <Redirect exact from={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR} to={RouterPath.myProcedure.steps.MP_1_ID} />

            <Route exact path={rp.PURCHASER_DEMAND_ID_PREVIEW} component={PurchaserPreviewPanel} />
            <Route exact path={rp.PURCHASER_DEMAND_ID_PREVIEW_ID_STAGE_ID_SECTION} component={PurchaserPreviewPanel} />

            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID} component={PurchaserStepperPages}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE} component={PurchaserStepperPages}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID} component={PurchaserStepperPages}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID_SECTION} component={PurchaserStepperPages}/>

            <Route component={NotFound}/>
        </Switch>
    )
}

export default PurchaserDemand;
